// @ts-nocheck
/* eslint-disable */
import { store } from '~/state/store';
import Content from './content';
import { getDetailImage } from "~/util/cdn";
import { deferPromise } from "~/util/general";
import { firmStats, isFirmFromPoi } from "~/util/review";
import { CONFIG } from '~/config';

export default class BestImage extends Content {
	getPosterData() {
		return this._promiseData.promise;
	}

	handleEvent(e) {
		if (isFirmFromPoi(this._data)) {
			const { data } = store.getState().detail;

			firmStats("firmy-vizitka-akce", data, { typeId: 17 });
		}

		if (Mapy.Util.linkToNewWindow(e)) {
			return;
		}

		e.preventDefault();

		Mapy.getComponent("detail").openGallery();
		Mapy.getComponent("history").save();
	}

	_build() {
		this._promiseData = deferPromise();

		var photo = this._data.best.urls["16x9"] ? this._data.best.urls["16x9"] : null;

		if (photo) {
			const url = getDetailImage(photo);
			var link = document.createElement("a");
			link.setAttribute("href", "//" + CONFIG.BASE_URL + "/?source=" + this._data.source + "&id=" + this._data.id + "&gallery=1");
			if (!this._data.isBooking) {
				link.setAttribute("data-log-text", "photoCover");
			}
			link.addEventListener("click", this, false);

			var img = document.createElement("img");

			if (this._data.isBooking) {
				link.classList.add("booking-cover");
				img.classList.add("landscape");
				img.addEventListener("load", function() {
					var pW = 400;
					var pH = 225;
					var w = img.naturalWidth;
					var h = img.naturalHeight;
					// spocitame novou sirku
					var cW = pH * w / h;

					if (cW < pW) {
						img.classList.remove("landscape");
						img.classList.add("portrait");
					}
				});
			}

			img.crossOrigin = "anonymous";
			img.src = url;

			link.appendChild(img);
			this._dom.container = link;

			this._promiseData.resolve([link, "bestImage", img]);
		} else {
			this._promiseData.reject({});
		}
	}
};
